import { paymentRequest, subscriptionRegister } from "../../api/payment";
import { SERVER_ENDPOINT } from "../../configs/env";
import DonateReceiptAgreeModal from "./donate_receipt_agree_modal";
import DonateStep1Modal from "./donate_step1_modal";
import ProductAuthModal from "./product_auth_modal";
import ProductDonateModal from "./product_donate_modal";

const DonationModalContainer = ({
  isProductModalOpen,
  isDonateReceiptAgreeModalOpen,
  isDonateStep1ModalOpen,
  isDonateStep2ModalOpen,
  agreeChecked,
  productId,
  phoneNumber,
  paymentSelect,

  setIsProductModalOpen,
  setIsDonateReceiptAgreeModalOpen,
  setIsDonateStep1ModalOpen,
  setIsDonateStep2ModalOpen,
  setPhoneNumber,
  setPaymentSelect,
  setAgreeChecked,

  kdBusiness,
  userRef,

  paymentType = "card", // ProductPage에서는 "card", DonationPage에서는 다른 값
}) => {
  const handleProductAuthSuccess = async (phoneNumber) => {
    if (productId !== "0") {
      // 일반 상품 결제
      const res = await paymentRequest(
        phoneNumber,
        paymentType,
        productId,
        kdBusiness || "",
        "키즈다-구독",
        "구독상품",
        "",
        agreeChecked,
        userRef || ""
      );

      if (res.success && res.data) {
        openPaymentPopup(res.data);
      }
      setIsProductModalOpen(false);
    } else {
      // 기부
      setIsProductModalOpen(false);
      setPhoneNumber(phoneNumber);
      setIsDonateReceiptAgreeModalOpen(true);
    }
  };

  const openPaymentPopup = (paymentData) => {
    const { formParams, orderNumber, paymentFormUrl } = paymentData;

    const params = new URLSearchParams({
      formParams: formParams,
      orderNumber: orderNumber,
      paymentFormUrl: paymentFormUrl,
      autoStart: "true",
    });

    const popupUrl = `${
      SERVER_ENDPOINT
    }/view/payment?${params.toString()}`;

    const popupOptions = [
      "width=800",
      "height=700",
      "scrollbars=yes",
      "resizable=yes",
      "toolbar=no",
      "menubar=no",
      "location=no",
      "directories=no",
      "status=no",
    ].join(",");

    const popup = window.open(popupUrl, "payment_popup", popupOptions);

    if (!popup) {
      alert("팝업이 차단되었습니다. 팝업 차단을 해제해주세요.");
      return;
    }

    popup.focus();

    const messageHandler = (event) => {
      if (event.origin !== SERVER_ENDPOINT) {
        return;
      }

      if (event.data.type === "PAYMENT_COMPLETE") {
        console.log("결제 완료", event.data);

        handlePaymentComplete(event.data);
        popup.close();
        window.removeEventListener("message", messageHandler);
      } else if (event.data.type === "PAYMENT_CANCEL") {
        console.log("결제 취소", event.data);

        handlePaymentCancel(event.data);
        popup.close();
        window.removeEventListener("message", messageHandler);
      } else if (event.data.type === "PAYMENT_ERROR") {
        console.log("결제 오류", event.data);

        handlePaymentError(event.data);
        popup.close();
        window.removeEventListener("message", messageHandler);
      }
    };

    window.addEventListener("message", messageHandler);

    const checkClosed = setInterval(() => {
      if (popup.closed) {
        clearInterval(checkClosed);
        window.removeEventListener("message", messageHandler);
      }
    }, 1000);
  };

  const handlePaymentComplete = (paymentResult) => {
    console.log("결제가 완료되었습니다", paymentResult);

    alert("결제가 완료되었습니다.");
  };

  const handlePaymentCancel = (cancelData) => {
    console.log("결제가 취소되었습니다", cancelData);
    alert("결제가 취소되었습니다.");
  };

  const handlePaymentError = (errorData) => {
    console.log("결제 오류가 발생했습니다", errorData);
    alert(
      `결제 오류: ${
        errorData.data?.message || "알 수 없는 오류가 발생했습니다."
      }`
    );
  };

  const handleDonateReceiptAgreeSuccess = async (value) => {
    setIsDonateReceiptAgreeModalOpen(false);
    setIsDonateStep1ModalOpen(true);
    setAgreeChecked(value);
  };

  const handleDonateStep1Success = async (value) => {
    setIsDonateStep1ModalOpen(false);
    setIsDonateStep2ModalOpen(true);
    setPaymentSelect(value);
  };

  const handleProductDonateSuccess = async (
    name,
    amount,
    paymentType,
    subscriptionData
  ) => {
    let res;

    if (paymentSelect === "single") {
      // 일회성 기부
      res = await paymentRequest(
        phoneNumber,
        paymentType || "",
        productId,
        kdBusiness || "",
        name,
        "정기후원",
        amount,
        agreeChecked,
        userRef || ""
      );

      // 기부 결제도 팝업으로 처리
      if (res.success && res.data) {
        openPaymentPopup(res.data);
      }
    } else {
      // 정기 기부
      res = await subscriptionRegister(
        0,
        amount,
        subscriptionData["payment_day"],
        subscriptionData["cardNumb"],
        subscriptionData["expiryDate"],
        subscriptionData["password2"],
        subscriptionData["userInfo"],
        subscriptionData["buyer_name"],
        subscriptionData["payment_content"],
        kdBusiness || "",
        agreeChecked,
        userRef || ""
      );

      if (res.success === true) {
        alert("정기후원이 성공적으로 등록되었습니다.");
      }
    }

    setIsDonateStep2ModalOpen(false);
  };

  const handleDonateStep1Back = () => {
    setIsDonateStep1ModalOpen(false);
    setIsDonateReceiptAgreeModalOpen(true);
  };

  const handleProductDonateBack = () => {
    setIsDonateStep2ModalOpen(false);
    setIsDonateStep1ModalOpen(true);
  };

  return (
    <>
      <ProductAuthModal
        isOpen={isProductModalOpen}
        onClose={() => setIsProductModalOpen(false)}
        onSuccess={handleProductAuthSuccess}
      />

      <DonateReceiptAgreeModal
        isOpen={isDonateReceiptAgreeModalOpen}
        onClose={() => setIsDonateReceiptAgreeModalOpen(false)}
        onSuccess={handleDonateReceiptAgreeSuccess}
      />

      <DonateStep1Modal
        isOpen={isDonateStep1ModalOpen}
        onBack={handleDonateStep1Back}
        onClose={() => setIsDonateStep1ModalOpen(false)}
        onSuccess={handleDonateStep1Success}
      />

      <ProductDonateModal
        isOpen={isDonateStep2ModalOpen}
        onBack={handleProductDonateBack}
        onClose={() => setIsDonateStep2ModalOpen(false)}
        phoneNumber={phoneNumber}
        paymentSelect={paymentSelect}
        onSuccess={handleProductDonateSuccess}
      />
    </>
  );
};

export default DonationModalContainer;
